module.exports = __webpack_public_path__ + "img/scan-qr.aafc1485.gif";